(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cotton-product-hero-landing"] && !Shopify.designMode) return;
  try {
    
  /* Thumbnail gallery switcher */
  document.querySelectorAll('.cotton-lhero__gallery').forEach(function(gallery) {
    gallery.querySelectorAll('.cotton-lhero__thumb').forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        var idx = thumb.getAttribute('data-index');
        gallery.querySelectorAll('.cotton-lhero__gallery-main-img').forEach(function(slide) {
          var isActive = slide.getAttribute('data-index') === idx;
          slide.classList.toggle('is-active', isActive);
          var vid = slide.querySelector('video');
          if (vid) {
            if (isActive) { vid.play().catch(function(){}); }
            else { vid.pause(); }
          }
        });
        gallery.querySelectorAll('.cotton-lhero__thumb').forEach(function(t) {
          t.classList.toggle('is-active', t.getAttribute('data-index') === idx);
        });
      });
    });
  });

  /* UGC video play/pause */
  document.querySelectorAll('.cotton-lhero__ugc-tile').forEach(function(tile) {
    var video = tile.querySelector('.cotton-lhero__ugc-video');
    var playBtn = tile.querySelector('.cotton-lhero__ugc-play');
    if (!video || !playBtn) return;
    playBtn.addEventListener('click', function() {
      if (video.paused) {
        video.play();
        tile.classList.add('is-playing');
      } else {
        video.pause();
        tile.classList.remove('is-playing');
      }
    });
    video.addEventListener('click', function() {
      video.pause();
      tile.classList.remove('is-playing');
    });
  });

  /* Description read more toggle */
  document.querySelectorAll('.cotton-lhero__description-toggle').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var wrap = btn.closest('.cotton-lhero__description');
      var expanded = wrap.classList.toggle('is-expanded');
      btn.setAttribute('aria-expanded', expanded);
      btn.innerHTML = expanded ? 'Lees minder <span aria-hidden="true">\u2191</span>' : 'Lees meer <span aria-hidden="true">\u2193</span>';
    });
  });

  /* Info tabs switcher */
  document.querySelectorAll('.cotton-lhero__tabs').forEach(function(tabs) {
    var btns = tabs.querySelectorAll('.cotton-lhero__tab-btn');
    var panels = tabs.querySelectorAll('.cotton-lhero__tab-panel');
    btns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        btns.forEach(function(b) { b.classList.remove('is-active'); b.setAttribute('aria-selected', 'false'); });
        panels.forEach(function(p) { p.classList.remove('is-active'); p.hidden = true; });
        btn.classList.add('is-active');
        btn.setAttribute('aria-selected', 'true');
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (panel) { panel.classList.add('is-active'); panel.hidden = false; }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
